import { render, staticRenderFns } from "./order-products-dialog.vue?vue&type=template&id=5e3b641c&"
import script from "./order-products-dialog.vue?vue&type=script&lang=js&"
export * from "./order-products-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports